import { FuelTab, FuelTabContent, FuelTabItem, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import useTruckInformationEvents from 'hooks/events/useTruckInformationEvents';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { isRecentDocument } from 'utils/isRecentDocument';
import * as Styled from './styled';
import TruckDetails from './truckDetails';

const TruckInformation: FC<{ data: ITruckerProfileProps }> = ({ data }) => {
  const MAIN_TRUCK = 0;

  const { truckerProfileOpenned } = useTruckInformationEvents();
  const hasMultiplesVehicles = data?.trucker?.vehicles?.length > 1;
  const [clicksQuantity, setClicksQuantity] = useState(0);
  const [currentTruck, setCurrentTruck] = useState(MAIN_TRUCK);
  const truckType = ['main', 'second', 'third'];

  const recentDocuments = useMemo(
    () => data?.trucker?.vehicles.map((vehicle) => isRecentDocument(vehicle?.rntrcEmissionDate)),
    [data?.trucker?.vehicles]
  );

  useEffect(() => {
    if (!!data?.trucker?.vehicles?.length) {
      truckerProfileOpenned(
        truckType[currentTruck],
        data?.trucker?.id,
        data?.trucker?.vehicles[currentTruck]?.id,
        clicksQuantity,
        data?.trucker?.vehicles[currentTruck].images.length
      );
    }
  }, [clicksQuantity, currentTruck]);

  const handleTabClick = (truck: number) => {
    setCurrentTruck(truck);
    setClicksQuantity(clicksQuantity + 1);
  };

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        customPadding: `${DS_TOKENS.spacing.km4} ${DS_TOKENS.spacing.km8} ${DS_TOKENS.spacing.km6}`,
      }}
    >
      <FuelTypography
        size="heading-sm"
        weight="bold"
        spacingBottom={parseFloat(DS_TOKENS.spacing.km6)}
        data-testid="vehicles-section-title"
      >
        Veículos
      </FuelTypography>

      <FuelTab divider={hasMultiplesVehicles}>
        {data?.trucker?.vehicles?.map((vehicle, index) => (
          <React.Fragment key={`vehicle-${vehicle.tractor.plate}`}>
            {hasMultiplesVehicles && (
              <FuelTabItem onClick={() => handleTabClick(index)} slot="tabs">
                {index === 0 ? 'Veículo principal' : `Veículo ${index + 1}`}
                {recentDocuments[index] && <Styled.SelectedPoint />}
              </FuelTabItem>
            )}
            <FuelTabContent slot="panels">
              <TruckDetails data={vehicle} />
            </FuelTabContent>
          </React.Fragment>
        ))}
      </FuelTab>
    </FuelFlex>
  );
};

export default TruckInformation;
